import { render, staticRenderFns } from "./overall-missing-data-card.vue?vue&type=template&id=33e47a54&scoped=true&"
import script from "./overall-missing-data-card.vue?vue&type=script&lang=js&"
export * from "./overall-missing-data-card.vue?vue&type=script&lang=js&"
import style0 from "./overall-missing-data-card.vue?vue&type=style&index=0&id=33e47a54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e47a54",
  null
  
)

component.options.__file = "overall-missing-data-card.vue"
export default component.exports